var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":"Phone","message":_vm.errors.get('phone'),"type":{ 'is-danger': _vm.errors.has('phone') }}},[_c('b-input',{attrs:{"type":"text","value":_vm.value,"maxlength":"14"},on:{"input":_vm.parseNumber}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }